import { Grid, Icon, Typography } from 'gu-ui-kit'
import { Trans } from 'react-i18next'
import { Link } from 'react-router-dom'
import React from 'react'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import clsx from 'clsx'
import { useSelector } from 'react-redux'

export const EmailDisapproved = ({ className }) => {
  const { is_email_confirmed = false } = useSelector((state) => ({
    is_email_confirmed: state['app'].user.is_email_confirmed,
  }))

  const pathGen = useGeneratePathI18n()

  return is_email_confirmed ? null : (
    <Grid
      className={clsx(
        styles['billing__notification'],
        styles['billing__notification_error'],
        className,
      )}
      direction={'row'}
      wrap={false}
      gap={16}
    >
      <Icon
        size={'m'}
        name={'status warning'}
        color={'Accent-Error-Secondary'}
      />
      <Grid direction={'column'}>
        <Typography
          component={'span'}
          variant={'Body-20'}
        >
          <Trans i18nKey="billing::email_disapproved_message.description">
            Чтобы создать платежный профиль, подтвердите свой email
            <Link to={pathGen(ROUTES.USER_SETTINGS)}>в настройках</Link>
          </Trans>
        </Typography>
      </Grid>
    </Grid>
  )
}

EmailDisapproved.propTypes = {
  className: PropTypes.string,
  isEmailConfirmed: PropTypes.bool,
}
